export function addDownloadAttribute() {
    // Select all div elements with the class 'is-style-download'
    var downloadDivs = document.querySelectorAll('.is-style-download');
  
    // Loop through each selected div
    downloadDivs.forEach(function(div) {
      // Find the anchor tag inside the current div
      var anchorTag = div.querySelector('a');
  
      // If an anchor tag is found, add the 'download' attribute
      if (anchorTag) {
        anchorTag.setAttribute('download', '');
      }
    });
  }
  